import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { DataService_ScheduledJobs } from "../../../shared/data.service";

@Component({
	selector: "app-ri-job-add-users",
	templateUrl: "./ri-job-add-users.component.html",
	styleUrls: ["./ri-job-add-users.component.css"],
})
export class RiJobAddUsersComponent implements OnInit {
	constructor(private ref: DynamicDialogRef, private dialogConfig: DynamicDialogConfig, private dataService: DataService_ScheduledJobs) {}

	ngOnInit(): void {
		this.loadUsers();
	}

	/////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////

	pagerows: any = 10;
	pagefirst: any = 0;
	lstUsers: any = [];
	SelectedUsers: any = [];
	cols: any = [
		{ field: "Username", header: "Username" },
		{ field: "StaffID", header: "Staff ID" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
	];

	TableLoading: boolean = false;
	errorMessage: string = "";

	/////////////////////////////////////////////////////

	loadUsers() {
		this.TableLoading = true;

		var result = this.dataService.JobAddUsersSelectList();
		result.subscribe(
			(response) => {
				this.lstUsers = response;

				this.SelectedUsers = this.dialogConfig.data.SelectedUsers;

				this.TableLoading = false;
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	/////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////

	onAdd() {
		this.ref.close({
			Success: true,
			lstUsers: this.SelectedUsers,
		});
	}

	onClose() {
		this.ref.close(0);
	}

	/////////////////////////////////////////////////////

	/////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////

	IsLoading() {
		return this.TableLoading == true;
	}

	/////////////////////////////////////////////////////
}
